// src/components/Auth/LoginWrapper.js
import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import PhoenixLogin from './PhoenixLogin';
import CodeVerification from './CodeVerification';
import { getAuthToken, isSessionExpired } from '../../api/authSession';
import './AdminAuth.css';

const LoginWrapper = () => {
    const [step, setStep] = useState('login'); // 'login' or 'code_required'
    const [username, setUsername] = useState(''); // Store username for code verification step

    const token = getAuthToken();
    const isExpired = isSessionExpired();

    // If user is already authenticated with an active session, redirect directly to dashboard
    if (token && !isExpired) {
        return <Navigate to="/" replace />;
    }

    const handleLoginSuccess = (user) => {
        setUsername(user);
        setStep('code_required');
    };

    return (
        <div className="auth-page-wrapper">
            {step === 'login' ? (
                <PhoenixLogin onLoginSuccess={handleLoginSuccess} />
            ) : (
                <CodeVerification username={username} />
            )}
        </div>
    );
};

export default LoginWrapper;